// this is an autogenerated file from App/Account/Content/Calendar/New/AppointmentOverlay/Content/Old/SimilarPatients/Content/new-patient-mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Calendar_New_AppointmentOverlay_Content_Old_SimilarPatients_Content($patient: vaxiom_patients_insert_input!) {
  insert_vaxiom_patients_one(object: $patient) {
    _id
    id
    person {
      id
      first_name
      last_name
      greeting
    }
    professional_relationships {
      id
    }
  }
}

`